module.exports = __webpack_public_path__ + "assets/img/f77422a799d20d4ab4b112c489ac8a35.png";